import { useIntl } from '~/hooks/useIntl';
import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  value: number;
};

export const QuotationTotalCell = ({ value }: Props) => {
  const { formatCurrency } = useIntl();
  const total = formatCurrency(value);

  return <span className={desktopTruncateStyle}>{total}</span>;
};
